import { render, staticRenderFns } from "./CandidatesDashboardStats.vue?vue&type=template&id=6442151d&scoped=true"
import script from "./CandidatesDashboardStats.vue?vue&type=script&lang=js"
export * from "./CandidatesDashboardStats.vue?vue&type=script&lang=js"
import style0 from "./CandidatesDashboardStats.vue?vue&type=style&index=0&id=6442151d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6442151d",
  null
  
)

export default component.exports